<template>
  <div>
    <Modal title="选择人员" :value="visible" @on-visible-change="visibleChange">
      <Input v-model="searchValue" style="width:80%;margin-right:5px;"></Input>
      <Button @click="searchUsers" type="primary">确定</Button>
      <Table style="margin-top: 15px" ref="selectUsers" @on-selection-change="selectChange" :columns="columnsRender" :data="usersList"></Table>
      <Page ref="page" @on-change="changePage" :page-size="8" :total="pageTotal" size="small" show-elevator show-total />
      <div slot="footer">
        <Button @click="cancel">Cancel</Button>
        <Button @click="save" type="primary">Save</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import ajax from '../../../lib/ajax';

export default {
  name: 'selectUsers',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    orgId: {
      type: Number,
      required: true,
      default: 0
    }
  },
  data() {
    return {
      usersList: [],
      columnsRender: [
        {
          type: 'selection',
          width: 60,
          align: 'center'
        },
        {
          title: 'Name',
          key: 'name'
        }
      ],
      selectUsers: [],
      pageTotal: 0,
      searchValue: '',
    }
  },
  methods: {
    selectChange(selection) {
      this.selectUsers = selection
    },
    async save() {
      let userIds = []
      this.selectUsers.forEach(user => {
        userIds.push(user.value)
      })
      let data = {
        organizationUnitId: this.orgId,
        userIds: userIds
      }
      let rep = await ajax.post('/api/services/app/OrganizationUnit/AddUsersToOrganizationUnit', data)
      if (rep.data.success) {
        this.$emit('addSuccess')
      }
    },
    cancel() {
      this.$emit('input', false);
    },
    visibleChange(value) {
      if (!value) {
        this.$emit('input', value);
      }
    },
    async searchUsers() {
      if (this.orgId !== 0) {
        let data = {
          filter: this.searchValue,
          maxResultCount: 8,
          organizationUnitId: this.orgId,
          skipCount: 0
        }
        let rep = await ajax.post('/api/services/app/OrganizationUnit/FindUsers', data)
        if (rep.data.success) {
          this.usersList = rep.data.result.items
          this.pageTotal = rep.data.result.totalCount
          this.$refs.page.currentPage = 1
        }
      }
    },
    async changePage(page) {
      const skipCount = 8 * (page - 1)
      let data = {
        filter: this.searchValue,
        maxResultCount: 8,
        organizationUnitId: this.orgId,
        skipCount: skipCount
      }
      let rep = await ajax.post('/api/services/app/OrganizationUnit/FindUsers', data)
      if (rep.data.success) {
        this.usersList = rep.data.result.items
      }
    }
  },
  watch: {
    visible: async function (newVal) {
      if (newVal) {
        if (this.orgId !== 0) {
          let data = {
            filter: '',
            maxResultCount: 8,
            organizationUnitId: this.orgId,
            skipCount: 0
          }
          let rep = await ajax.post('/api/services/app/OrganizationUnit/FindUsers', data)
          if (rep.data.success) {
            this.usersList = rep.data.result.items
            this.pageTotal = rep.data.result.totalCount
          }
        }
      }
    }
  }
}
</script>
